module.exports = __webpack_public_path__ + "static/media/2023-Q1-Market_Analysis_Services_Update.413846f0.htm";